import { ref } from 'vue';
import { RouteRecordRaw } from 'vue-router';
import { useDeviceBySerial } from 'composables/device';

const routes: RouteRecordRaw[] = [
  {
    path: '/',
    component: () => import('layouts/MainLayout.vue'),
    children: [
      { path: '', name: 'home', component: () => import('pages/Index.vue'), meta: { title: 'Customer Lookup' } },
      { path: '/logged-out', component: () => import('pages/LoggedOut.vue'), meta: { title: 'Logged Out' } },
    ],
  },
  {
    path: '/fulfillment',
    component: () => import('layouts/FulfillmentLayout.vue'),
    children: [
      {
        path: '',
        name: 'fulfillment',
        component: () => import('pages/Fulfillment.vue'),
        meta: { title: 'Find Order - Fulfillment' },
      },
    ],
  },
  {
    path: '/bulk-update',
    redirect: { name: 'bulkUpdate' },
  },
  {
    path: '/device-tools',
    component: () => import('layouts/LeftColumnLayout.vue'),
    children: [
      {
        path: '',
        name: 'deviceTools',
        redirect: { name: 'bulkUpdate' },
      },
      {
        path: 'bulk-update',
        name: 'bulkUpdate',
        component: () => import('pages/BulkUpdate.vue'),
        meta: { title: 'Bulk Config Update' },
      },
      {
        path: 'return-devices',
        name: 'returnDevices',
        component: () => import('pages/ReturnDevices.vue'),
        meta: { title: 'Return Devices' },
      },
    ],
  },
  {
    path: '/device/:serial',
    component: () => import('layouts/MainLayout.vue'),
    beforeEnter(to, _, next) {
      const { serial } = to.params;
      const { device, getDevice } = useDeviceBySerial(ref(<string>serial));
      void getDevice().then(() => {
        if (device.value.accountKey) {
          next({ name: 'accountDevice', params: { key: device.value.accountKey, serial } });
          return;
        }
        next({ name: 'accountlessDevice', params: { serial } });
      });
    },
  },
  {
    path: '/account/:key',
    component: () => import('layouts/AccountLayout.vue'),
    children: [
      {
        path: '',
        redirect: { name: 'accountDashboard' },
      },
      {
        path: 'overview',
        name: 'accountDashboard',
        component: () => import('pages/account/AccountDashboard.vue'),
      },
      {
        path: 'info',
        name: 'accountOverview',
        component: () => import('pages/account/AccountOverview.vue'),
      },
      {
        path: 'devices',
        name: 'accountDevices',
        component: () => import('pages/account/Devices.vue'),
      },
      {
        path: 'devices/:serial',
        name: 'accountDevice',
        component: () => import('pages/account/Device.vue'),
        children: [
          {
            path: 'sim-usage',
            name: 'accountDeviceSimUsage',
            component: () => import('pages/account/Device.vue'),
          },
        ],
      },
    ],
  },
  {
    path: '/accountless',
    component: () => import('layouts/AccountlessLayout.vue'),
    children: [
      {
        path: 'device/:serial',
        name: 'accountlessDevice',
        component: () => import('pages/DeviceWithoutAccount.vue'),
        meta: { noNav: true, title: 'Accountless Device' },
        children: [
          {
            path: 'sim-usage',
            name: 'accountlessDeviceSimUsage',
            component: () => import('pages/DeviceWithoutAccount.vue'),
          },
        ],
      },
    ],
  },
  {
    path: '/attributions',
    component: () => import('layouts/MainLayout.vue'),
    children: [
      {
        path: '',
        name: 'attributions',
        component: () => import('pages/Attributions.vue'),
        meta: { title: 'Attributions' },
      },
    ],
  },
  {
    path: '/error',
    component: () => import('pages/Error.vue'),
  },
  {
    path: '/forbidden',
    component: () => import('pages/Error403.vue'),
  },
  // Always leave this as last one,
  // but you can also remove it
  {
    path: '/:catchAll(.*)*',
    component: () => import('pages/Error404.vue'),
  },
];

export default routes;
